__webpack_require__.p = "/share/";